import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../environments/environment";
import { CrudService } from "./crud.service";
import { Founder } from "../models/founder";

@Injectable({
  providedIn: "root",
})
export class FoundersService extends CrudService<Founder, number> {
  constructor(protected override _http: HttpClient) {
    super(_http, `${environment.baseUrl}/founders`);
  }
}
